import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm, change } from 'redux-form';
import { api, updateExpiracion } from "api";
import Swal from 'sweetalert2';
import moment, { lang } from "moment";

const LOADER = 'CONSULT_LOADER';
const SET_RECETA = 'SET_RECETA';
const SET_CONSULT_SHEET = 'SET_CONSULT_SHEET';
const SET_IGSS_FORM_DATA = 'SET_IGSS_FORM_DATA';
const SET_OPTIC_ORDER_DATA = 'SET_OPTIC_ORDER_DATA';

export const sendIggsEmail = (appointment_id, pdf) => (dispatch) => {
    dispatch({type: LOADER, cargando: true});
    const attachments = [];
    
    if (pdf && pdf instanceof File) {
        attachments.push({
            name: 'pdf',
            archivo: pdf
        });        
    }    

    api.postAttachments(`medical_history/sendIgssEmail`, { appointment_id }, attachments)
    .then((data) => {
        dispatch({type: LOADER, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Correos enviados correctamente',
                'success'
            ).then(() => {
                //dispatch(push('/doctors'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER, cargando: false});
        console.log("catch error... ", error)
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )        
    })

    /*
    api.post(`medical_history/sendIgssEmail`, {appointment_id}).then((response) => {
        console.log("send igss email response :::. ", response);
        
    }).catch((error)=>{
        console.log("Error: ", error);
    });
    */    
}

export const getDiagnosticPlan = (appointment_id) => (dispatch) => {
  api.get(`consult/getDiagnosticPlan`, {appointment_id, marcar_inicio: true}).then((response) => {     
        //console.log("RESPONSE GET DIAGNOSTIC PLAN .:: ", response)
      let txn = []
      const dp_dpa_tx = response.dp_dpa.find(plan => plan.nombre == "PIVOTE")
      if(dp_dpa_tx){
          const newTdDp = dp_dpa_tx.td_dp.map(el => {
              return { 
                  ...el,
                  commercial_name: el.treatment.commercial_name,
                  active_principle: el.treatment.active_principle
              }
          })
          txn.push({ 'td_dp': newTdDp })
      }

      const dx = response.dp_dpa.filter(plan => plan.nombre !== "PIVOTE").map(f => { return { nombre: {value: f.id, label: f.nombre }}})
      
      const formData = { dx, txn, notes: response.notes, doctor: response.appointment.doctor }
      
      dispatch({type: SET_RECETA, receta: formData });      
  }).catch((error)=>{
      console.log("Error: ", error);
  }); 
}

export const getConsultSheet = (appointment_id) => (dispatch) => {
    api.get(`medical_history/getConsultSheet/`, {appointment_id}).then((response) => {        
        dispatch({type: SET_CONSULT_SHEET, consult_sheet: response });
    }).catch((error)=>{
        console.log("Error: ", error);
    }); 
}

export const getIgssForm = (id) => (dispatch) => {
    api.get(`igss-forms/${id}`, {}).then((response) => {        
        dispatch({type: SET_IGSS_FORM_DATA, igss_form: response });
    }).catch((error)=>{
        console.log("Error: ", error);
    });
}

export const getOpticsOrder = (appointment_id) => (dispatch) => {    
    api.get(`consult/getOpticsOrder`, {appointment_id}).then((response) => {
        //console.log("response optics order for print :::. ", response);
        const doctor_signature = response.appointment ? response.appointment.doctor ? response.appointment.doctor.signature : null : null;
        const formatResponse = { ...response, doctor_signature }
        delete formatResponse.appointment
        //dispatch({type: SET_OPTIC_ORDER_DATA, optics_order: response });
        dispatch({type: SET_OPTIC_ORDER_DATA, optics_order: formatResponse });
    }).catch((error)=>{
        console.log("Error: ", error);
    });
}

export const actions = {  
  getDiagnosticPlan,
  getConsultSheet,
  getIgssForm,
  getOpticsOrder,
  sendIggsEmail
};

export const reducers = {
  [LOADER]: (state, { loader }) => {
      return {
          ...state,
          loader,
      };
  },
  [SET_RECETA]: (state, { receta }) => {
      return {
          ...state,
          receta,
      };
  }, 
  [SET_CONSULT_SHEET]: (state, { consult_sheet }) => {
    return {
        ...state,
        consult_sheet,
    };
  },
  [SET_IGSS_FORM_DATA]: (state, { igss_form }) => {
    return {
        ...state,
        igss_form
    };
  },
  [SET_OPTIC_ORDER_DATA]: (state, { optics_order }) => {
    return {
        ...state,
        optics_order
    };
  }
};

export const initialState = {
  loader: false,  
  receta: null,
  consult_sheet: null,
  igss_form: null,
  optics_order: null
};

export default handleActions(reducers, initialState);
